'use client';
import { Icon as SharedIcon } from '@launchstore/shared-puck';
import type { IconProps } from '@launchstore/shared-puck';
export const Icon: any = SharedIcon;
export type { IconProps };
export default Icon;
